<template>
    <div>
        <b-table
                id="cdasExcluida"
                :items="resultado"
                :fields="fields"
                striped
                small
                responsive="sm"
                tbody-tr-class="rowClass"
                :no-local-sorting="true"
                @sort-changed="sortingChanged"
                :busy="configTable.load"
                show-empty
        >
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>

            <template slot="empty">
                <p class="my-auto">Nenhum registro encontrado.</p>
            </template>

            <template slot="HEAD_selecionar">
                <b-form-checkbox v-model="configTable.checkedAll" class="mx-auto justify-content-center text-center ml-1" @change="toggleAll" />
            </template>
            <template slot="selecionar" slot-scope="row">
                <template>
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :disabled="row.item.motivo != 'Duplicidade Ajuizamento'" :checked="row.item.checked" @change="toggleCheck($event, row.item, null, true)" />
                </template>
            </template>
            <template slot="1" slot-scope="row">
                <b-link @click="abrirModalExtratoCda(row.item.codCdaSefa)" class="text-center">
                    <p> {{ row.item.numeroDivida }} </p>
                </b-link>
            </template>
            <template slot="2" slot-scope="row">
                <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj" class="text-left">
                    {{ devedor.nome }}
                </p>
            </template>
            <template slot="3" slot-scope="row">
                <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj" class="text-left">
                    {{ devedor.cpfCnpj | cpfCnpj }}
                </p>
            </template>
            <template slot="4" slot-scope="row">
                <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj" class="text-left">
                    {{ devedor.cadicms }}
                </p>
            </template>
            <template slot="5" slot-scope="row">
                <p class="text-left">
                    {{ row.item.comarca }}
                </p>
            </template>
            <template slot="6" slot-scope="row" class="text-center">
                <p class="text-center">
                    {{ row.item.tipoCredito }}
                </p>
            </template>
            <template slot="7" slot-scope="row">
                <p class="text-center">
                    {{ row.item.dataInscricaoFormatada }}
                </p>
            </template>
            <template slot="8" slot-scope="row">
                <p class="text-right">
                    {{ row.item.valorTotal | currency }}
                </p>
            </template>
            <template slot="9" slot-scope="row" class="text-center">
                <p class="text-center">
                    {{ row.item.motivo }}
                </p>
            </template>
            <template slot="10" slot-scope="row" class="text-center">
                <p class="text-center">
                    {{ row.item.dataPagamentoFormatada }}
                </p>
            </template>
        </b-table>

        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>
</template>

<script>
    import ExtratoCda from "../../shared/components/ExtratoCda";
    export default {
        components: {ExtratoCda},
        props: ['resultado', 'fields', 'configTable','selecteds'],
        watch: {
            currentPage() {
                this.configTable.checkedAll = false
                this.$emit('consultarDividas')
            }
        },
        computed: {
            currentPage() {
                return this.configTable.currentPage
            }
        },
        methods: {
            sortingChanged(ctx) {
                if(ctx.sortBy == 1) {
                    this.configTable.sortField = 'numeroDivida';
                }
                if(ctx.sortBy == 2) {
                    this.configTable.sortField = 'contribuinte';
                }
                if(ctx.sortBy == 3) {
                    this.configTable.sortField = 'cpfCnpj';
                }
                if(ctx.sortBy == 4) {
                    this.configTable.sortField = 'cadicms';
                }
                if(ctx.sortBy == 5) {
                    this.configTable.sortField = 'comarca';
                }
                if(ctx.sortBy == 6) {
                    this.configTable.sortField = 'tipoCredito';
                }
                if(ctx.sortBy == 7) {
                    this.configTable.sortField = 'dataInscricao';
                }
                if(ctx.sortBy == 8) {
                    this.configTable.sortField = 'valorTotal';
                }
                if(ctx.sortBy == 9) {
                    this.configTable.sortField = 'motivo';
                }
                if(ctx.sortBy == 10) {
                    this.configTable.sortField = 'dataPagamentoParcelamento';
                }
                this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc';
                this.$emit('sortingChanged')
            },
            toggleAll(checked) {
                if(checked) {
                    this.resultado.forEach(el => {
                        if(el.motivo == 'Duplicidade Ajuizamento'){
                            el.checked = true;
                            if(!this.selecteds.includes(el.codCdaSefa)) {
                                this.selecteds.push(el.codCdaSefa);
                            }
                        }
                    })
                } else {
                    this.resultado.forEach(el => {
                        el.checked = false;
                        if(this.selecteds.includes(el.codCdaSefa)) {
                            const index = this.selecteds.indexOf(el.codCdaSefa);
                            this.selecteds.splice(index, 1);
                        }
                    })
                }
            },
            toggleCheck(checked, item) {
                if(checked) {
                    item.checked = checked;
                    this.selecteds.push(item.codCdaSefa);
                } else {
                    item.checked = checked;
                    const index = this.selecteds.indexOf(item.codCdaSefa);
                    this.selecteds.splice(index, 1);
                    this.configTable.checkedAll = false;
                }

            },
            abrirModalExtratoCda(codCdaSefa) {
                this.$refs['extratoCda'].abrirExtrato(codCdaSefa);
            },
            closeModal() {
                this.$refs['extratoCda'].fecharModais();
            },
        }
    }
</script>

<style>
    th {
        text-align: center !important;
    }
</style>
